import Vue from 'vue';
import Router from 'vue-router';

import Index from './pages/Index.vue';
import MainNavbar from './layout/MainNavbar.vue';
import MainFooter from './layout/MainFooter.vue';
import ProjectDetail from './pages/ProjectDetail.vue';

import Panel from './pages/panel/Index.vue';
import PanelOverview from './pages/panel/PanelOverview.vue';

import Profile from './pages/panel/Profile.vue';
import Notifications from './pages/panel/Notifications.vue';
import HelpCenter from './pages/panel/HelpCenter.vue';
import PortFolio from './pages/panel/Portfolio.vue';
import InvestDetail from './pages/panel/InvestDetail.vue';

import Settings from './pages/panel/Settings.vue';
import ProjectForm from './pages/panel/ProjectForm.vue';
import UserForm from './pages/panel/UserForm.vue';
import PermissionForm from './pages/panel/PermissionForm.vue';
import RoleForm from './pages/panel/RoleForm.vue';
import ConfigForm from './pages/panel/ConfigForm.vue';

import InvestView from './pages/InvestView.vue';
import InvestmentRegister from './pages/InvestmentRegister.vue';

import ConfirmEmail from './pages/ConfirmEmail.vue';
import Unconfirmed from './pages/Unconfirmed.vue';
import RestorePassword from './pages/RestorePassword.vue';

Vue.use(Router);

export default new Router({
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '*',
      redirect: { name: 'index' }
    },
    {
      path: '/',
      name: 'index',
      components: { default: Index, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/confirm',
      name: 'confirm',
      component: ConfirmEmail,
    },
    {
      path: '/unconfirmed',
      name: 'unconfirmed',
      component: Unconfirmed,
    },
    {
      path: '/restore_password',
      name: 'restore',
      component: RestorePassword,
    },
    {
      path: '/panel',
      name: 'panel',
      components: { default: Panel, header: MainNavbar, footer: MainFooter },
      children: [
        {
          path: '/',
          name: 'panel-overview',
          component: PanelOverview
        },
        {
          path: 'investments/:id',
          name: 'project-detail',
          component: ProjectDetail
        },
        {
          path: 'profile',
          name: 'Panel_Perfil',
          component: Profile
        },
        {
          path: 'notifications',
          name: 'Panel_Notifications',
          component: Notifications
        },
        {
          path: 'settings',
          name: 'Panel_Settings',
          component: Settings
        },
        {
          path: 'settings/projects',
          name: 'Project_New',
          component: ProjectForm
        },
        {
          path: 'settings/projects/:id',
          name: 'Project_Edit',
          component: ProjectForm
        },
        {
          path: 'settings/users',
          component: UserForm
        },
        {
          path: 'settings/users/:id',
          component: UserForm
        },
        {
          path: 'settings/roles',
          component: RoleForm
        },
        {
          path: 'settings/roles/:id',
          component: RoleForm
        },
        {
          path: 'settings/assign/:id',
          component: PermissionForm
        },
        {
          path: 'settings/configurations',
          component: ConfigForm
        },
        {
          path: 'settings/configurations/:id',
          name: 'Config_Edit',
          component: ConfigForm
        },
        {
          path: 'help',
          name: 'Panel-Hepl',
          component: HelpCenter
        },
        {
          path: 'invest',
          name: 'invest',
          component: InvestView
        },
        {
          path: 'portfolio',
          name: 'portfolio',
          component: PortFolio
        },
        {
          path: 'portfolio/invest',
          name: 'invest_detail',
          component: InvestDetail
        }
      ]
    },
    {
      path: '/investments',
      name: 'detail',
      components: { default: ProjectDetail, header: MainNavbar, footer: MainFooter},
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/investment/registered',
      name: 'invest-registered',
      component: InvestmentRegister,
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
